<template>
  <div style="background: #f8f8f8">
    <section class="padding-fifteen-lr">
      <b-container>
        <b-row>
          <b-col cols="12" class="padding-ten-tb float-left padding-left-none">
            <h5 class="title__name text-xl">Proveedores</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="float-left padding-left-none">
            <h5 class="main__section_title_color text-large font-weight-600">
              Consulta
            </h5>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="padding-fifteen-lr">
      <b-container>
        <b-row>
          <b-col
            xs="12"
            sm="12"
            md="12"
            lg="5"
            class="bg-white section__border-radius align-vertical-middle"
          >
            <b-row>
              <b-col cols="4" md="6" lg="6" class="section__filter_border">
                <b-form-select
                  class="border-none font-size-12 font-weight-400"
                  @change="clearSelectedFilters"
                  v-model="selectedFilter"
                  :options="optionsTypeDoc"
                ></b-form-select>
              </b-col>
              <b-col cols="8" md="6" lg="6">
                <b-form-input
                  v-if="selectedFilter == 'a'"
                  v-on:keyup.enter="getProviders"
                  type="text"
                  v-model="filterSearch.documentValue"
                  class="border-none section__filter-small grey-input"
                  placeholder="Escriba aquí .."
                ></b-form-input>
                <b-form-input
                  v-else-if="selectedFilter == 'b'"
                  v-on:keyup.enter="getProviders"
                  type="text"
                  class="border-none section__filter-small grey-input"
                  v-model="filterSearch.user"
                  placeholder="Escriba aquí .."
                ></b-form-input>
                <b-form-input
                  v-else
                  v-on:keyup.enter="getProviders"
                  type="text"
                  class="border-none section__filter-small grey-input"
                  v-model="filterSearch.storeCode"
                  placeholder="Escriba aquí .."
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="2" xs="12" sm="12" md="12" lg="2">
            <b-button @click="getProviders" class="rounded-button border-none">
              <font-awesome-icon icon="search" />
            </b-button>
          </b-col>
          <b-col
            cols="12"
            xs="12"
            sm="12"
            md="12"
            lg="5"
            class="float-right main__section_title_color"
          >
            <!-- <b-button class="section__button_trans border-none">
              <font-awesome-icon icon="plus" />

              Filtrar
            </b-button> -->
            <b-button
              v-if="optionCreate"
              class="section__button_trans border-none"
              @click="$router.push('crear-proveedor')"
            >
              <font-awesome-icon icon="plus" />
              Agregar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <template v-if="providers.length">
      <section>
        <b-container>
          <b-row>
            <b-col
              cols="12"
              class="padding-ten-tb float-left padding-left-none"
            >
              <h5 class="title__name text-large" style="color: #585858">
                Resultados Proveedores
              </h5>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section>
        <b-container>
          <b-row>
            <b-col
              cols="12"
              class="bg-white section__border-radius padding-ten-all"
            >
              <b-table
                class="hidden-xs"
                show-empty
                small
                :busy="isBusy"
                striped
                :items="providers"
                :fields="fields"
                :current-page="currentPage"
                :per-page="0"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    v-if="optionEdit"
                    
                    size="sm"
                    @click="getDetailsProvider(row.item, $event.target)"
                    class="mr-1 btn-rounded-orange border-none"
                    >EDITAR
                  </b-button>
                  <b-button
                    v-if="optionInactive&&row.item.state == 'ACTIVE'"
                    size="sm"
                    @click="deleteProvider(row.item, $event.target)"
                    class="mr-1 btn-rounded-red border-none"
                    >INACTIVAR
                  </b-button>
                  
                </template>
              </b-table>
              <b-row>
                <b-col cols="12" class="text-center">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalProviders"
                    :per-page="perPage"
                    pills
                    align="center"
                    size="md"
                    class="my-0"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
    <template v-else>
      <section class="margin-two-top">
        <b-container>
          <b-row>
            <b-col
              cols="12"
              class="bg-white section__border-radius padding-all-fifty"
            >
              <p class="text-medium color-black font-weight-bold">
                Proveedores
              </p>
              <span>
                Haga click directamente en el ícono de búsqueda o ingrese un
                valor en el buscador y/o filtro
              </span>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import store from "@/store";
import { mapState } from "vuex";
export default {
  name: "Proveedores",
  data() {
    return {
      selectedState: "ALL",
      optionStates: [
        { value: "ACTIVE", text: "Activo" },
        { value: "INACTIVE", text: "Inactivo" },
        { value: "ALL", text: "Todos" },
      ],
      filterSearch: {
        documentValue: "",
        user: "",
        storeCode: "",
      },
      sortBy: "",
      currentPage: 1,
      perPage: 10,
      optionsTypeDoc: [
        { value: null, text: "Elige un Parámetro" },
        { value: "a", text: "RUC" },
        { value: "b", text: "USUARIO" },
        { value: "c", text: "SUCURSAL" },
      ],
      selectedFilter: "b",
      documentValue: "",
      providers: [],
      fields: [
        {
          key: "ruc",
          label: "RUC",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "socialReason",
          label: "Razón social",
          sortable: true,
        },
        {
          key: "state",
          label: "Estado",
          sortable: true,
        },
        { key: "user", label: "Usuario", sortable: true },
        { key: "name", label: "Representante", sortable: true },
        { key: "actions", label: "" },
      ],
      isBusy: false,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      countTotal: 0,
    };
  },
  watch: {
    currentPage: {
      handler: function () {
        this.getProviders().catch((error) => {
          console.error(error);
        });
      },
    },
  },
  computed: {
    ...mapState("module", ["perfil", "options"]),
    rows() {
      return this.providers.length;
    },
    isProfileProvider() {
      if (this.perfil.toUpperCase() === "PROVEEDOR") return true;
      return false;
    },
    optionCreate() {
      //id 11 Crear
      return this.options.some((m) => m.id == 11);
    },
    optionEdit() {
      //id 12 Editar
      return this.options.some((m) => m.id == 12);
    },
    optionInactive() {
      //id 18 Inactivar
      return this.options.some((m) => m.id == 18);
    },
    totalProviders() {
      if (this.currentPage == 1 && this.providers.length < 10) return 10;
      return this.countTotal;
    },
  },
  beforeRouteEnter(to, from, next) {
    let menu = store.getters["module/optionsMenu"];
    let authProvider= menu.some((m) => m.id == 6);
    if (!authProvider) next({ name: "BlockedPage" });
    else next();
  },
  created() {
    this.getCountProviders();
  },
  methods: {
    async getCountProviders() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers/count"
        );

        this.countTotal = response.data.number;
      } catch (error) {
        this.countTotal = 100;
      }
    },
    clearSelectedFilters() {
      this.filterSearch.documentValue = "";
      this.filterSearch.user = "";
      this.filterSearch.storeCode = "";
    },
    async getProviders() {
      try {
        //this.isBusy = true;
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/providers?limit=" +
            this.perPage +
            "&page=" +
            this.currentPage +
            "&user=" +
            this.filterSearch.user +
            "&storeCode=" +
            this.filterSearch.storeCode +
            "&ruc=" +
            this.filterSearch.documentValue +
            "&state=" +
            this.selectedState
        );

        this.providers = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        //this.isBusy = false;
      }
    },
    getDetailsProvider(item) {
      this.$router.push({ path: `/editar-proveedor/${item.id}` });
    },
    async deleteProvider(item) {
      try {
        this.isBusy = true;
        this.$store.commit("SET_LOADING", true);
        let response = await axios.delete(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS + "/providers/" + item.id
        );
        console.log(response);

        let values = {
          variant: "success",
          msg: "Se ha inactivado exitosamente !",
        };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.getProviders();
        //this.providers = response.data;
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        this.isBusy = false;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}

::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}

::v-deep .b-time-seconds {
  pointer-events: none;
}
::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}
.btn-orange-tra {
  border-radius: 50%;
}

input.grey-input::placeholder {
  color: #000000 !important;
  font-size: 12x;
}
::v-deep .b-table thead th {
  font-weight: 600 !important;
  border: none !important;
  font-size: 14px;
}
::v-deep .table td {
  color: black;
  font-size: 14px;
  border-top: 1px solid #ff8000 !important;
}

@media (max-width: 600px) {
  .padding-fifteen-lr {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
